import { Textarea, SIZE } from 'baseui/textarea'

const SDTextarea = ({ ...rest }) => {
  if (rest.hidden) return null
  return <Textarea size={rest.size ?? SIZE.compact} {...rest} />
}

export default SDTextarea